
import Vue from "vue";
import { OrganizationsService, UserCreateSchema } from "@/commons/client";
import { UserSchema } from "@/commons/client";
import { UsersService } from "@/commons/client";
import { Alert } from "@/commons/types";
import Alerter from "@/components/Alerter.vue";

export default Vue.extend({
  name: "UserCreateView",

  components: {
    Alerter,
  },

  data: () => ({
    passwordIsClear: false,
    // userData: {
    //   username: "",
    //   password: "",
    //   email: "",
    //   first_name: "",
    //   last_name: "",
    // },
    alerts: [] as Alert[],
    userData: {} as UserCreateSchema,
    organizations: [] as { id: number; name: string }[],
    // user: {} as UserCreateSchema,
  }),

  computed: {
    rules() {
      return this.$store.state.genericRules;
    },
    isValidForm() {
      const { has_limited_data_access, access_start_time, access_end_time } =
        this.userData;

      if (has_limited_data_access) {
        if (!access_start_time || !access_end_time) return false;

        // Normalizza formato a HH:MM
        const start = access_start_time.slice(0, 5);
        const end = access_end_time.slice(0, 5);

        if (start === end) return false; // stesso orario = non valido

        return true; // valido anche se scavalca mezzanotte
      }

      return true;
    },
  },

  methods: {
    showHidePassword() {
      this.passwordIsClear = !this.passwordIsClear;
    },
    async createUser(): Promise<void> {
      if (!this.isValidForm) {
        this.alerts.push({
          type: "error",
          text: "Orario di accesso non valido: controlla inizio e fine.",
        });
        return;
      }

      try {
        // Normalizza orari
        let start = this.userData.access_start_time || "00:00";
        let end = this.userData.access_end_time || "23:59";

        if (start.length === 5) start += ":00";
        if (end.length === 5) end += ":00";

        const payload: UserCreateSchema = {
          ...this.userData,
          access_start_time: start,
          access_end_time: end,
        };

        const user = await UsersService.userCreateV1UsersPost(payload);

        this.alerts.push({
          type: "success",
          text: "Utente creato con successo",
        });

        this.userData = {} as UserCreateSchema;
        this.redirectAfterUserCreation(user);
      } catch (err) {
        this.alerts.push({
          type: "error",
          text: "Errore durante la creazione dell'utente",
        });
      }
    },
    async fetchOrganizations() {
      this.organizations =
        await OrganizationsService.organizationListV1OrganizationsGet(
          undefined,
          100,
          "",
          undefined
        );
    },
    redirectAfterUserCreation(user: UserSchema) {
      if (user.organization_id) {
        this.$router.push({
          name: "organizationDetail",
          params: { pk: `${user.organization_id}` },
        });
      } else {
        this.$router.push({
          name: "organizationCreate",
          query: { ownerId: `${user.id}` },
        });
      }
    },
  },

  mounted() {
    this.fetchOrganizations();
  },
});
